import React from 'react';
import {useTalent} from "../../providers/TalentProvider";

const TalentTileBadges = (props) => {

    const {talent} = useTalent();

    if (!talent || !talent.matching_pools?.length) {
        return null;
    }
    return (
        <div className="absolute flex flex-col items-start gap-2 -left-1.5 top-3 justify-center">
            {talent.isFavorited() && (
                <div className="flex flex-row gap-1.5 items-center">
                    <i className="fas fa-heart w-[18px] text-center"/>
                    <p className="text-[0.65rem]">Favorite</p>
                </div>
            )}
            {talent.isInNetwork() && (
                <div className="flex flex-row gap-1.5 items-center">
                    <i className="fas fa-bolt w-[18px] text-center"/>
                    <p className="text-[0.65rem]">In Network</p>
                </div>
            )}
            {talent.isPastHire() && (
                <div className="flex flex-row gap-1.5 items-center">
                    <div className="w-[18px] flex flex-col justify-center items-center">
                        <span className="fa-stack small text-center">
                            <i className="far fa-circle fa-stack-2x"></i>
                            <i className="fas fa-dollar-sign fa-stack-1x"></i>
                        </span>
                    </div>
                    <p className="text-[0.65rem]">Past Hire</p>
                </div>
            )}
            {talent.isInTalentPool() && (
                <div className="flex flex-row gap-1.5 items-center">
                    <i className="fas fa-users w-[18px] text-center"/>
                    <p className="text-[0.65rem]">Saved to Pool</p>
                </div>
            )}
            {talent.isWrippleRecommended() && (
                <div className="flex flex-row gap-1.5 items-center">
                    <img src={TB.logoImagePath()} className="h-[17px] w-[17px]"/>
                    <p className="text-[0.65rem] whitespace-pre">Recommended</p>
                </div>
            )}
        </div>
    )
};

export default TalentTileBadges;